import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-paper-clip-icon',
  template: `
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_28083_18642)">
        <path
          d="M11.0013 3.99935V11.666C11.0013 13.1393 9.80797 14.3327 8.33464 14.3327C6.8613 14.3327 5.66797 13.1393 5.66797 11.666V3.33268C5.66797 2.41268 6.41464 1.66602 7.33464 1.66602C8.25464 1.66602 9.0013 2.41268 9.0013 3.33268V10.3327C9.0013 10.6993 8.7013 10.9993 8.33464 10.9993C7.96797 10.9993 7.66797 10.6993 7.66797 10.3327V3.99935H6.66797V10.3327C6.66797 11.2527 7.41464 11.9993 8.33464 11.9993C9.25464 11.9993 10.0013 11.2527 10.0013 10.3327V3.33268C10.0013 1.85935 8.80797 0.666016 7.33464 0.666016C5.8613 0.666016 4.66797 1.85935 4.66797 3.33268V11.666C4.66797 13.6927 6.30797 15.3327 8.33464 15.3327C10.3613 15.3327 12.0013 13.6927 12.0013 11.666V3.99935H11.0013Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_28083_18642">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PagerClipIconComponent {}
